var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAgave(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 511.999 511.999",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91CC04"
    },
    d: "M215.889,423.632c24.143,8.08,50.266-4.942,58.346-29.086c8.08-24.143-4.942-50.266-29.086-58.346 c-24.143-8.08-236.83-57.494-244.91-33.35S191.746,415.552,215.889,423.632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#85BB04"
    },
    d: "M245.149,336.2c-15.321-5.127-106.565-26.899-173.271-35.956 c6.788,8.118,74.816,82.787,94.573,102.52c24.105,10.843,43.003,18.714,49.437,20.867c24.143,8.08,50.266-4.942,58.346-29.086 C282.315,370.402,269.293,344.28,245.149,336.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9CDD05"
    },
    d: "M296.109,423.632c-24.143,8.08-50.266-4.942-58.346-29.086c-8.08-24.144,4.942-50.266,29.086-58.346 c24.143-8.08,236.831-57.494,244.911-33.351C519.841,326.992,320.253,415.552,296.109,423.632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91CC04"
    },
    d: "M440.12,300.243c-66.705,9.058-157.95,30.829-173.27,35.956 c-24.143,8.08-37.165,34.202-29.086,58.345c8.08,24.143,34.202,37.165,58.346,29.086c6.434-2.154,25.332-10.024,49.437-20.867 C365.304,383.031,433.332,308.363,440.12,300.243z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#85BB04"
    },
    d: "M196.74,353.23c10.997,22.963,38.526,32.662,61.488,21.665 c22.963-10.997,32.662-38.526,21.665-61.488c-10.997-22.963-123.501-210.1-146.463-199.104S185.743,330.268,196.74,353.23z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#85BB04"
    },
    d: "M321.054,353.23c-10.997,22.963-38.526,32.662-61.488,21.665 c-22.963-10.997-32.662-38.526-21.665-61.488s123.501-210.1,146.463-199.104C407.326,125.301,332.05,330.268,321.054,353.23z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#79AB03"
    },
    d: "M279.894,313.408c-6.248-13.046-45.264-79.091-82.008-131.681 c-0.588,3.635-14.255,108.078-16.055,133.794c6.933,18.732,12.484,32.647,14.909,37.711c10.997,22.963,38.526,32.662,61.488,21.665 C281.192,363.899,290.891,336.37,279.894,313.408z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#79AB03"
    },
    d: "M336.082,315.198c-1.482-26.243-13.614-131.344-14.32-136.117 c-37.274,52.997-77.508,121.06-83.862,134.327c-10.997,22.963-1.296,50.491,21.665,61.488 c22.963,10.997,50.491,1.296,61.488-21.665C323.492,348.138,329.093,334.092,336.082,315.198z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91CC04"
    },
    d: "M212.799,328.422c-0.207,25.458,20.263,46.266,45.721,46.473 c25.458,0.207,46.266-20.263,46.473-45.721c0.207-25.458-18.658-242.995-44.116-243.202S213.007,302.964,212.799,328.422z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9CDD05"
    },
    d: "M209.273,400.033c19.454,16.423,48.539,13.967,64.962-5.487 c16.423-19.454,13.967-48.539-5.487-64.962S69.88,188.707,53.457,208.161S189.819,383.61,209.273,400.033z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C2FB3B"
    },
    d: "M302.725,400.033c-19.454,16.423-48.539,13.967-64.962-5.487 c-16.423-19.454-13.967-48.539,5.487-64.962s198.868-140.877,215.291-121.423S322.18,383.61,302.725,400.033z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9CDD05"
    },
    d: "M337.364,320.455c-3.297-2.855-3.362-7.973-0.388-11.163c1.765-1.891,3.545-3.808,5.338-5.746 c2.962-3.202,7.96-3.399,11.161-0.435c3.202,2.962,3.397,7.959,0.435,11.161c-1.809,1.954-3.605,3.888-5.383,5.796 C346.971,321.734,341.56,324.088,337.364,320.455z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9CDD05"
    },
    d: "M276.313,380.988c-2.926-3.235-2.393-8.315,0.94-11.129c4.267-3.604,21.737-20.666,43.436-43.334 c3.016-3.151,8.015-3.26,11.167-0.243c3.151,3.016,3.26,8.016,0.243,11.167c-20.901,21.832-39.455,40.087-44.658,44.48 C285.96,383.179,280.746,385.888,276.313,380.988z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgave);
export default __webpack_public_path__ + "static/media/agave.86695cb196166f979b2e38ae50dc7234.svg";
export { ForwardRef as ReactComponent };